import { createContext, useContext } from "react";
import { MapCanvasStageState } from "./MapCanvasContext.types";

export const MapCanvasStageContext =
  createContext<MapCanvasStageState | null>(null);

export const useMapCanvasStage = () => {
  const context = useContext(MapCanvasStageContext);
  if (!context) {
    throw new Error(
      "useMapCanvasStage must be used within a MapCanvasProvider"
    );
  }
  return context;
};
